export * from './allocation-view.guard';
